export default {
  meta: {
    title: '一鸣选址决策报告PDF',
    parentPath: '/expandstore/chancepoint',
    breadcrumbs: ['机会点', '选址决策报告'],
  },
};
